import { isSharedStation } from '@app/core/stations/helpers';
import EmergencyIcon from '@mui/icons-material/Emergency';
import { Box, Tooltip } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';
import { useIntl } from 'react-intl';
import { sharedStationTooltipMessage } from './station-messages';
import { MinimumStation, Station } from '@app/core/types/stations';

type SharedStationIconSize = 'small' | 'medium';

const ICON_FONT_SIZE: Record<SharedStationIconSize, string> = {
  small: '0.875rem',
  medium: '1rem',
};

interface SharedStationIconProps {
  station?: Station | MinimumStation | null;
  size?: SharedStationIconSize;
  sx?: SxProps<Theme>;
  iconSx?: SxProps<Theme>;
}

/**
 * Renders a shared-station indicator icon when the station has SHARED access type.
 */
export function SharedStationIcon({
  station,
  size = 'medium',
  sx,
  iconSx,
}: SharedStationIconProps) {
  const { $t } = useIntl();

  if (!station || !('accessType' in station) || !isSharedStation(station as Station)) {
    return null;
  }

  return (
    <Tooltip title={$t(sharedStationTooltipMessage)}>
      <Box component="span" display="inline-flex" alignItems="center">
        <Box
          sx={
            [
              {
                display: 'inline-flex',
                alignItems: 'center',
                color: 'text.secondary',
                flexShrink: 0,
              },
              sx,
            ] as SxProps<Theme>
          }
        >
          <EmergencyIcon
            sx={
              [
                {
                  fontSize: ICON_FONT_SIZE[size],
                },
                iconSx,
              ] as SxProps<Theme>
            }
          />
        </Box>
      </Box>
    </Tooltip>
  );
}
